import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector, useDispatch } from 'react-redux';
import { resetSearch } from '@store/reducers/search';
import {apiRoleMappingPagingAction} from '@store/reducers/apiRoleMapping';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import { Image } from 'react-bootstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import {
    APIROLEMAPPING_API,
    AUTH_APIROLEMAPPING_API,
    BaseGatewayImage,
    ROLE_API
} from '@app/utils/apiUrl.js';
import { DeleteSingle, Get, Post } from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import { URI_INTERNAL } from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    objectDeviceStatus,
    deviceStatus,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue
} from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { BrowserView, MobileView } from 'react-device-detect';
import Select from 'react-select';
import SelectTree from '@app/components/select-tree/SelectTree';
import { NIL as NIL_UUID } from 'uuid';

const ApiRoleMapping = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const paramUrl = new URLSearchParams(location.search.substring(1));
    const [page, setPage] = useState(paramUrl.get('page') ? parseInt(paramUrl.get('page'), 10) : 1);
    const [pageSize, setPageSize] = useState(paramUrl.get('size') ? parseInt(paramUrl.get('size'), 10) : 20);
    const [search, setSearch] = useState(paramUrl.get('search') || '');
    const [mappingSource, setMappingSource] = useState('webapi');
    const mappingApi = mappingSource === 'auth'
        ? AUTH_APIROLEMAPPING_API
        : APIROLEMAPPING_API;

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    // let accountRoleAdmin = false;
    // const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role;
    //     accountRoleAdmin =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    // }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(mappingApi.DELETE_ITEM, value, null)
    );

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['apiRoleMappingData', mappingSource, search, page, pageSize],
        () => {
            let model = {
                Keyword: search ? search : '',
                PageIndex: page,
                PageSize: pageSize
            };

            replaceHistory(page, pageSize, search ? search : '');

            return Get(mappingApi.GET_PAGING, null, model);
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.APIROLEMAPPING_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    // Reset search khi rời trang
    React.useEffect(() => {
        return () => { dispatch(resetSearch()); };
    }, []);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            deleteFunc.mutate(idWantDelete, {
                onSuccess: (res) => {
                    if (res.status === 201 || res.status === 200) {
                        refetch();
                        toast.success(messageToast.messageToastDeleteSuccess);
                        if (
                            data != null &&
                            data.data.length === 1 &&
                            page !== 1
                        ) {
                            history.push(
                                createUrlWithParam(
                                    URI_INTERNAL.APIROLEMAPPING_PATH,
                                    {
                                        page: page - 1,
                                        size: pageSize,
                                        search: search
                                    }
                                )
                            );
                        }
                    } else {
                        toast.error(messageToast.messageToastDeleteError);
                    }
                },
                onError: (res) => {
                    toast.error(messageToast.messageToastTryCatch);
                }
            });

            replaceHistory(page, pageSize, search);
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    // chọn nhiều dòng + chọn roles
    const [selectedIds, setSelectedIds] = useState(new Set()); // id của các dòng đã tick
    const [selectedRoles, setSelectedRoles] = useState([]);    // các role chọn bởi AsyncPaginate

    const listRole = useQuery(['getAllRolesFromAuthServer'], () =>
        Get(ROLE_API.GET_PAGING, null, {
            PageIndex: 1,
            PageSize: 10000
        })
    );

    const lstRoleFlat =
        listRole?.data?.data?.length > 0
            ? listRole.data.data.map((x) => ({
                id: x.id,
                name: x.name,
                // normalize root parentId to NIL_UUID
                parentId:
                    x.parentId && x.parentId !== NIL_UUID ? x.parentId : NIL_UUID,
            }))
            : [];

    // === Chọn tất cả trên trang / chọn từng dòng ===
    const currentPageIds = data?.data?.map((x) => x.id) ?? [];
    const isAllPageChecked =
        currentPageIds.length > 0 && currentPageIds.every((id) => selectedIds.has(id));

    const toggleCheckAllPage = () => {
        setSelectedIds((prev) => {
            const next = new Set(prev);
            if (isAllPageChecked) {
                // Bỏ chọn tất cả
                currentPageIds.forEach((id) => next.delete(id));
            } else {
                // Chọn tất cả
                currentPageIds.forEach((id) => next.add(id));
            }
            return next;
        });
    };

    const toggleRow = (id) => {
        setSelectedIds((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    // === Bulk assign roles ===
    const bulkAssignMutation = useMutation((payload) =>
        Post(mappingApi.BULK_ASSIGN_ROLES, null, payload)
    );

    const onApplyRolesForSelected = () => {
        if (selectedIds.size === 0) {
            toast.warn('Vui lòng chọn ít nhất một dòng.');
            return;
        }
        if (!selectedRoles || selectedRoles.length === 0) {
            toast.warn('Vui lòng chọn ít nhất một quyền.');
            return;
        }

        // Chuẩn hoá về dạng AllowedRole[] theo đúng DTO của BE
        const allowedRolesForSend = selectedRoles.map(r => ({
            id: r.id,         // Guid
            name: r.name ?? r.label ?? r.value // tuỳ nguồn dữ liệu, ưu tiên name
        }));

        // Lấy các ApiRoleMapping đã tick và gắn LstAllowedRoles cho từng item
        const itemsForSend = (data?.data ?? [])
            .filter(x => selectedIds.has(x.id))
            .map(x => ({
                id: x.id,                  // Guid? nếu BE không cần Id khi bulk-add mới, có thể bỏ
                controller: x.controller,  // theo ApiRoleMappingRequest
                action: x.action,          // theo ApiRoleMappingRequest
                lstAllowedRoles: allowedRolesForSend
            }));

        // Gọi API: endpoint nhận List<ApiRoleMappingRequest>
        bulkAssignMutation.mutate(itemsForSend, {
            onSuccess: () => {
                toast.success('Áp dụng quyền thành công.');
                setSelectedIds(new Set());
                // (tuỳ chọn) Optimistic update UI cột "Các quyền cho phép dùng"
                // setData(prev => ({
                //   ...prev,
                //   data: prev.data.map(row =>
                //     selectedIds.has(row.id)
                //       ? { ...row, lstAllowedRoles: allowedRolesForSend }
                //       : row
                //   )
                // }));
                refetch();
                dispatch(
                    apiRoleMappingPagingAction({PageIndex: 1, PageSize: 10000})
                );
            },
            onError: () => {
                toast.error('Áp dụng quyền thất bại, vui lòng thử lại.');
            },
        });
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="d-flex align-items-center">
                                <h3 className="card-title mb-0 mr-3">
                                    Danh sách nội dung đề nghị
                                </h3>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ width: '400px' }}
                                    placeholder="Nhập tên Controller để tìm kiếm (Nhấn Enter)"
                                    defaultValue={search}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            setPage(1);
                                            setSearch(e.target.value);
                                            replaceHistory(1, pageSize, e.target.value);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                                <form className="form-inline" onSubmit={(e) => e.preventDefault()}>
                                    <label className="mr-2">Nguồn API:</label>
                                    <select
                                        className="form-control mr-3"
                                        value={mappingSource}
                                        onChange={(e) => {
                                            setMappingSource(e.target.value);
                                            setPage(1);
                                            setSelectedIds(new Set());
                                        }}
                                    >
                                        <option value="webapi">WebApi</option>
                                        <option value="auth">AuthService</option>
                                    </select>
                                    <label
                                        htmlFor="exampleEmail2"
                                        className="mr-2"
                                    >
                                        Hiển thị :
                                    </label>
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={(e) => onChangeShowNumber(e)}
                                        style={{ marginRight: "20px" }}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option
                                                key={Number(key)}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                    {/* <AsyncPaginate
                                        isMulti
                                        name="lstAllowedRoles"
                                        placeholder="Chọn quyền được cho phép truy cập"
                                        value={selectedRoles}
                                        getOptionLabel={(opt) => opt.name}
                                        getOptionValue={(opt) => opt.id}
                                        loadOptions={loadOptions}
                                        onChange={(options) => setSelectedRoles(options || [])}
                                        additional={{ page: 1 }}
                                    />

                                    <button
                                        style={{ marginLeft: "20px" }}
                                        type="button"
                                        className="btn btn-success ml-2"
                                        disabled={
                                            selectedIds.size === 0 ||
                                            (selectedRoles?.length ?? 0) === 0 ||
                                            bulkAssignMutation.isLoading
                                        }
                                        onClick={onApplyRolesForSelected}
                                        title="Áp dụng quyền cho các dòng đã chọn"
                                    >
                                        Áp dụng quyền cho mục đã chọn
                                    </button> */}

                                    <SelectTree
                                        data={lstRoleFlat}
                                        showSearchBox
                                        Placeholder="Chọn quyền được phép truy cập"
                                        positionExpand="right"
                                        multiSelect
                                        onChange={(valueArray) => {
                                            // SelectTree (multiSelect=true) returns an array of selected items
                                            setSelectedRoles(valueArray || []);
                                        }}
                                    />

                                    <button
                                        style={{ marginLeft: "20px" }}
                                        type="button"
                                        className="btn btn-success ml-2"
                                        disabled={
                                            selectedIds.size === 0 ||
                                            (selectedRoles?.length ?? 0) === 0 ||
                                            bulkAssignMutation.isLoading
                                        }
                                        onClick={onApplyRolesForSelected}
                                        title="Áp dụng quyền cho các dòng đã chọn"
                                    >
                                        Áp dụng quyền cho mục đã chọn
                                    </button>
                                </form>
                                <NavLink
                                    className="nav-link-reject nav-link"
                                    to={`${URI_INTERNAL.APIROLEMAPPING_CREATE_PATH}?source=${mappingSource}`}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                    >
                                        Thêm mới
                                    </button>
                                </NavLink>
                            </div>

                            {isLoading ? (
                                <div>Đang tải...</div>
                            ) : isError ? (
                                <div>Có lỗi xảy ra: ${error.message}</div>
                            ) : (
                                <div
                                    id="example2_wrapper"
                                    className="dataTables_wrapper dt-bootstrap4"
                                // style={{
                                //     marginTop: accountRoleAdmin
                                //         ? '0px'
                                //         : '20px'
                                // }}
                                >
                                    <div className="row">
                                        <div
                                            className="col-sm-12"
                                            style={{ overflow: 'auto' }}
                                        >
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr role="row">
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Tên controller
                                                        </th>
                                                        <th className="sorting">
                                                            Tên Action
                                                        </th>
                                                        <th className="sorting">
                                                            Các quyền cho phép
                                                            dùng
                                                        </th>
                                                        <th className="sorting" style={{ width: 36, textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={isAllPageChecked}
                                                                onChange={toggleCheckAllPage}
                                                                title="Chọn/bỏ chọn tất cả trên trang"
                                                            />
                                                        </th>
                                                        <th className="sorting">
                                                            Chức năng
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {data != null &&
                                                    data.data != null &&
                                                    data.data != null &&
                                                    data.data !== undefined &&
                                                    data.data.length > 0 ? (
                                                    <tbody>
                                                        {data.data.map(
                                                            (item, index) => (
                                                                <tr
                                                                    key={Number(
                                                                        index
                                                                    )}
                                                                    className="odd"
                                                                >
                                                                    <td className="dtr-control sorting_1">
                                                                        {index +
                                                                            1 +
                                                                            (page -
                                                                                1) *
                                                                            pageSize}
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.controller
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.action
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {item.lstAllowedRoles
                                                                            ?.map(
                                                                                (
                                                                                    x
                                                                                ) =>
                                                                                    x.name
                                                                            )
                                                                            .join(
                                                                                ', '
                                                                            )}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedIds.has(item.id)}
                                                                            onChange={() => toggleRow(item.id)}
                                                                            title={`Chọn ${item.controller}.${item.action}`}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <ul className="nav">
                                                                            <li className="nav-item">
                                                                                <NavLink
                                                                                    to={createUrlWithParam(
                                                                                        URI_INTERNAL.APIROLEMAPPING_EDIT_PATH,
                                                                                        {
                                                                                            id: item.id,
                                                                                            source: mappingSource
                                                                                        }
                                                                                    )}
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Sửa"
                                                                                        className="nav-icon font-icon fas fa-pen"
                                                                                    />
                                                                                </NavLink>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <NavLink
                                                                                    onClick={() =>
                                                                                        deleteAction(
                                                                                            item.id,
                                                                                            item.noiDungDeNghi
                                                                                        )
                                                                                    }
                                                                                    to
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Xóa"
                                                                                        className="nav-icon font-icon far fa-trash-alt"
                                                                                    />
                                                                                </NavLink>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                        <tr className="txt-center">
                                                            <td colSpan="12">
                                                                Không có dữ liệu
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}
                                                <tfoot>
                                                    <tr role="row">
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Tên controller
                                                        </th>
                                                        <th className="sorting">
                                                            Tên Action
                                                        </th>
                                                        <th className="sorting">
                                                            Các quyền cho phép
                                                            dùng
                                                        </th>
                                                        <th></th>
                                                        <th className="sorting">
                                                            Chức năng
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div
                                                className="dataTables_paginate paging_simple_numbers"
                                                id="example2_paginate"
                                            >
                                                <Pagination
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    innerClass="pagination pagination-sm no-margin pull-right"
                                                    activePage={page}
                                                    itemsCountPerPage={Number(
                                                        pageSize
                                                    )}
                                                    totalItemsCount={
                                                        data != null
                                                            ? data.totalRecords
                                                            : 0
                                                    }
                                                    pageRangeDisplayed={5}
                                                    onChange={(number) =>
                                                        changePage(number)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={() => acceptDelete()}
                                handleCancel={() => cancelDelete()}
                                content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApiRoleMapping;
